import "./libs/infiniteslidev2";
import "./libs/slick.js";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";


import {binder} from "./libs/binder";
import {constants, handleResponsiveMove} from "./modules/module";
import {mobileNav} from "./modules/mobileNav";
import {stickyHeader} from "./modules/stickyHeader";
import {customSelect} from "./modules/customSelect";
import {footerNavigation} from "./modules/footerNavigation.js";
import {parallax} from "./modules/parallax";
import {logosSlider} from "./modules/logosSlider";
import {tabs} from "./modules/tabs";
import {videoBg} from "./modules/videoBg";
import {sliderSection} from "./modules/sliderSection";
import {accordion} from "./modules/accordion";
import {featuresGridSliderMobile} from "./modules/featuresGridSliderMobile";
import {colorShiftText} from "./modules/colorShiftText";
import {popups} from "./modules/popups";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {scrollTo} from "./modules/scrollTo.js";
import {productPageSlider} from "./modules/productPageSlider.js";
import {featuredProductsSlider} from "./modules/featuredProductsSlider";
import {fileUpload} from "./modules/fileUpload";
import {copyHrefToBuffer} from "./modules/copyHrefToBuffer";


binder({
    bounds: {
        "html": [constants, handleResponsiveMove],
        ".header": [mobileNav, stickyHeader],
        "select": customSelect,
        ".footer .nav-header": footerNavigation,
        ".has-parallax": parallax,
        ".logos-section": logosSlider,
        ".tabs-holder": tabs,
        ".section-poster": videoBg,
        ".slider-section .slider": sliderSection,
        ".accordion-heading": accordion,
        ".features-grid.slider-on-mobile": featuresGridSliderMobile,
        ".section-color-shift": colorShiftText,
        ".popup-opener": popups,
        ".copy-link": copyLinkToBuffer,
        ".cards-nav": scrollTo,
        ".product-images": productPageSlider,
        ".featured-products-slider": featuredProductsSlider,
        ".custom-upload": fileUpload,
        ".copy-href": copyHrefToBuffer
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js